import React from 'react';
import { t } from '../i18n';

const DeleteAccount = () => {
    const contactEmail = process.env.REACT_APP_CONTACT_EMAIL || 'support@painttheworld.app';

    return (
        <div style={styles.container}>
            <h1 style={styles.heading}>{t('web.deleteAccount.title')}</h1>
            <p style={styles.updated}>{t('web.deleteAccount.lastUpdated')}</p>
            <p style={styles.intro}>
                {t('web.deleteAccount.intro')}
            </p>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.deleteAccount.howTitle')}</h2>
                <p style={styles.body}>
                    {t('web.deleteAccount.howFastest')}
                </p>
                <p style={styles.body}>
                    <strong style={{ color: '#fff' }}>{t('web.deleteAccount.howPath')}</strong>
                </p>
                <p style={styles.body}>
                    {t('web.deleteAccount.howEmailBefore')}{' '}
                    <a href={`mailto:${contactEmail}`} style={styles.link}>{contactEmail}</a> {t('web.deleteAccount.howEmailAfter')}
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.deleteAccount.whatTitle')}</h2>
                <p style={styles.body}>{t('web.deleteAccount.whatIntro')}</p>
                <ul style={styles.list}>
                    <li>{t('web.deleteAccount.whatItemProfile')}</li>
                    <li>{t('web.deleteAccount.whatItemTiles')}</li>
                    <li>{t('web.deleteAccount.whatItemColor')}</li>
                    <li>{t('web.deleteAccount.whatItemIdentifiers')}</li>
                    <li>{t('web.deleteAccount.whatItemOther')}</li>
                </ul>
                <p style={styles.note}>
                    {t('web.deleteAccount.whatNote')}
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.deleteAccount.retainTitle')}</h2>
                <p style={styles.body}>{t('web.deleteAccount.retainIntro')}</p>
                <ul style={styles.list}>
                    <li><strong style={{ color: '#eee' }}>{t('web.deleteAccount.retainLegalLabel')}</strong> {t('web.deleteAccount.retainLegalBody')}</li>
                    <li><strong style={{ color: '#eee' }}>{t('web.deleteAccount.retainSecurityLabel')}</strong> {t('web.deleteAccount.retainSecurityBody')}</li>
                </ul>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.deleteAccount.timelineTitle')}</h2>
                <p style={styles.body}>
                    {t('web.deleteAccount.timelineBody')}
                </p>
            </section>

            <section style={styles.section}>
                <h2 style={styles.sectionHeading}>{t('web.deleteAccount.contactTitle')}</h2>
                <p style={styles.body}>
                    {t('web.deleteAccount.contactBody')}{' '}
                    <a href={`mailto:${contactEmail}`} style={styles.link}>{contactEmail}</a>
                </p>
            </section>
        </div>
    );
};

const styles: Record<string, React.CSSProperties> = {
    container: {
        maxWidth: 640,
        margin: '0 auto',
        padding: '24px 16px',
        fontFamily: 'system-ui, sans-serif',
        color: '#eee',
        backgroundColor: '#111',
        minHeight: '100vh',
    },
    heading: { color: '#fff', fontSize: 28, fontWeight: 700, marginBottom: 4 },
    updated: { color: '#666', fontSize: 13, marginBottom: 12 },
    intro: { color: '#aaa', lineHeight: 1.7, marginBottom: 28 },
    section: { marginBottom: 28 },
    sectionHeading: { color: '#fff', fontSize: 18, fontWeight: 600, marginBottom: 12 },
    body: { color: '#eee', lineHeight: 1.7, marginBottom: 10 },
    list: { color: '#eee', lineHeight: 1.8, paddingLeft: 20, marginBottom: 10 },
    note: { color: '#888', fontSize: 13, lineHeight: 1.6, fontStyle: 'italic' },
    link: { color: '#6ab4ff' },
};

export default DeleteAccount;
